import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=945805e8&"
import script from "./Assessment.vue?vue&type=script&lang=ts&"
export * from "./Assessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('945805e8')) {
      api.createRecord('945805e8', component.options)
    } else {
      api.reload('945805e8', component.options)
    }
    module.hot.accept("./Assessment.vue?vue&type=template&id=945805e8&", function () {
      api.rerender('945805e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/Assessment.vue"
export default component.exports